import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p>
        Made with <span className="heart">❤️</span> by{' '}
        <a 
          href="https://github.com/moddingfriendly" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          ModdingFriendly
        </a>
      </p>
    </footer>
  );
}

export default Footer; 